import { Autocomplete, Avatar, Box, Button, Card, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, Select, Step, StepButton, Stepper, Switch, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";
import MDTypography from "components/MDTypography";
import React from "react";
import colors from "assets/theme/base/colors";

export const DocumentDialog = ({ documentOpen, handleDocumentClose, documents, jobOfferDetail, handleDocumentChange, setJobOfferDetail, makeJobOffer, selectedValues }) => {
    return (
        <>
            <Dialog
                PaperProps={{
                    style: {
                        backgroundColor: "white",
                        boxShadow: "none",
                        width: "500px",
                        height: "450px",
                        maxWidth: "none",
                    },
                }}
                open={documentOpen}
                onClose={handleDocumentClose}
            >
                <DialogTitle
                    style={{
                        padding: "20px",
                        borderBottom: "1px solid ",
                        background: "#EC407A",
                        color: "lavenderblush",
                    }}
                >
                    <Typography variant="h5" style={{ color: "white" }}>
                        Required Document
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <MDBox py={3} pb={2}>
                        <MDBox p={1}>
                            <MDTypography variant="body2" color="text.secondary">
                                {documents?.map((value) => {
                                    const handleChange = () => handleDocumentChange(value.id);
                                    const isChecked = selectedValues?.includes(value.id);
                                    // const isChecked = selectedValues?.includes(key) || selectedDocs.includes(parseInt(key, 10));

                                    return (
                                        <MDBox
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems={{ xs: "center", sm: "center" }}
                                            flexDirection={{ xs: "row", sm: "row" }}
                                        >
                                            <MDBox lineHeight={2}>
                                                <MDTypography variant="button" color="text">
                                                    {value.name}
                                                </MDTypography>
                                            </MDBox>
                                            <MDBox>
                                                <input
                                                    key={value.id}
                                                    checked={isChecked}
                                                    onChange={() => {
                                                        handleChange();
                                                    }}
                                                    type="checkbox"
                                                />
                                            </MDBox>
                                        </MDBox>
                                    );
                                })}
                            </MDTypography>
                        </MDBox>
                        <Grid container spacing={3}>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    id="name"
                                    label="Expected CTC"
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                    name="ctc"
                                    value={jobOfferDetail?.ctc}
                                    onChange={(event) => {
                                        setJobOfferDetail((state) => ({
                                            ...state,
                                            ctc: event.target.value,
                                        }));
                                    }}
                                    inputProps={{}}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    id="e_doj"
                                    label="Expected Date of Joining"
                                    type="date"
                                    fullWidth
                                    variant="standard"
                                    name="Expected Date of Joining"
                                    placeholder=""
                                    value={jobOfferDetail?.expected_doj}
                                    onChange={(event) => {
                                        setJobOfferDetail((state) => ({
                                            ...state,
                                            expected_doj: event.target.value,
                                        }));
                                    }}
                                    inputProps={{}}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    id="validtill"
                                    label="Valid till"
                                    type="date"
                                    fullWidth
                                    variant="standard"
                                    name="Valid till"
                                    placeholder=""
                                    value={jobOfferDetail?.valid_till}
                                    onChange={(event) => {
                                        setJobOfferDetail((state) => ({
                                            ...state,
                                            valid_till: event.target.value,
                                        }));
                                    }}
                                    inputProps={{}}
                                />
                            </Grid>
                        </Grid>
                    </MDBox>
                </DialogContent>
                <DialogActions>
                    <MDButton
                        variant="contained"
                        color="dark"
                        onClick={handleDocumentClose}
                    >
                        Cancel
                    </MDButton>
                    <MDButton
                        variant="contained"
                        color="dark"
                        onClick={async () => {
                            await makeJobOffer();
                        }}
                    >
                        Done
                    </MDButton>
                </DialogActions>
            </Dialog>

        </>
    )
}

export const ScheduleInterviewDialog = ({ scheduleInterviewOpen, handleScheduleInterviewClose, showAlert, employeesList, interviewTimeError, interviewTime, interviewDateError, interviewDate, description, finalInterview, interviewerNameError, setScheduleInterviewRecord, setInterviewerNameError, setInterviewTime, setInterviewTimeError, setInterviewDate, setInterviewDateError, setDescription, setFinalInterview, gmeetAuthenticated, handleScheduleInterview, setShowAlert, scheduleInterviewRecord, meetingModeError, setMeetingModeError }) => {
    const alertContent = (name) => (
        <MDTypography variant="body2" color="white">
            {name}
        </MDTypography>
    );

    return (
        <>
            <Dialog
                PaperProps={{
                    style: {
                        backgroundColor: "white",
                        borderRadius: "22px",
                        width: "620px",
                        maxWidth: "92vw",
                    },
                }}
                open={scheduleInterviewOpen}
                onClose={handleScheduleInterviewClose}
            >
                {showAlert && (
                    <MDAlert
                        color="primary"
                        dismissible
                        onClick={() => {
                            setShowAlert(null);
                        }}
                    >
                        {alertContent(showAlert)}
                    </MDAlert>
                )}
                <DialogTitle
                    style={{
                        borderBottom: "50px solid",
                        background: `linear-gradient(135deg, ${colors.info.main} 0%, ${colors.primary.main} 100%)`,
                        color: "white",
                    }}
                >
                    <Typography variant="h5" style={{ color: "white" }}>
                        Schedule Interview
                    </Typography>
                    <Typography variant="body2" style={{ color: "rgba(255,255,255,0.86)" }}>
                        Add the exact interview logistics so the recruiter and interviewer stay in sync.
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Box
                        sx={{
                            mt: 2,
                            mb: 1,
                            p: 1.5,
                            borderRadius: "16px",
                            backgroundColor: colors.background.accent,
                            border: `1px solid ${colors.info.main}20`,
                        }}
                    >
                        <Typography fontWeight={700}>
                            Candidate interview setup
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Pick the interviewer, set the schedule, and choose whether this round is online or offline.
                        </Typography>
                    </Box>
                    <Grid item xs={22} sm={12}>
                        <Autocomplete
                            id="interviewerName"
                            multiple
                            key={employeesList.length}
                            options={employeesList || []}
                            getOptionLabel={(option) =>
                                option.user.firstname + " " + option.user.lastname
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                    fullWidth
                                    name="interviewerName"
                                    label="Interviewer Name"
                                    required
                                    error={!!interviewerNameError}
                                    helperText={interviewerNameError}
                                />
                            )}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    setScheduleInterviewRecord((state) => ({
                                        ...state,
                                        interviewer: newValue
                                    }));
                                }
                                setInterviewerNameError("");
                            }}
                        />
                    </Grid>
                    <Grid
                        container
                        spacing={4}
                        sx={{ marginTop: -3 }}
                        alignItems={"center"}
                    >
                        <Grid item xs={12}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                margin="dense"
                                id="interviewDatetime"
                                label="Interview Date & Time"
                                type="datetime-local"
                                fullWidth
                                variant="outlined"
                                name="interviewDatetime"
                                required
                                error={!!interviewDateError || !!interviewTimeError}
                                helperText={interviewDateError || interviewTimeError}
                                value={scheduleInterviewRecord?.datetime || ""}
                                onChange={(event) => {
                                    setScheduleInterviewRecord((state) => ({
                                        ...state,
                                        datetime: event.target.value,
                                    }));
                                    setInterviewDate(event.target.value);
                                    setInterviewTime(event.target.value);
                                    setInterviewDateError("");
                                    setInterviewTimeError("");
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth margin="dense">
                                <InputLabel id="candidate-meeting-mode-label">Interview Mode</InputLabel>
                                <Select
                                    labelId="candidate-meeting-mode-label"
                                    value={scheduleInterviewRecord?.mode || "online"}
                                    label="Interview Mode"
                                    onChange={(event) => {
                                        setScheduleInterviewRecord((state) => ({
                                            ...state,
                                            mode: event.target.value,
                                        }));
                                        setMeetingModeError("");
                                    }}
                                >
                                    <MenuItem value="online">Online</MenuItem>
                                    <MenuItem value="offline">Offline</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                margin="dense"
                                label="Timezone"
                                fullWidth
                                variant="outlined"
                                value={scheduleInterviewRecord?.timezone || "Asia/Kolkata"}
                                onChange={(event) => {
                                    setScheduleInterviewRecord((state) => ({
                                        ...state,
                                        timezone: event.target.value,
                                    }));
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                margin="dense"
                                id="date"
                                label="Description"
                                // placeholder="Description"
                                fullWidth
                                variant="outlined"
                                name="interviewDate"
                                required
                                value={description}
                                onChange={(event) => setDescription(event.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <MDTypography variant="h8">Final Interview</MDTypography>
                            <Switch
                                checked={finalInterview}
                                onChange={() => {
                                    setFinalInterview(!finalInterview);
                                }}
                            />
                        </Grid>
                        {scheduleInterviewRecord?.mode === "online" ? (
                            <Grid item xs={12}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    margin="dense"
                                    label="Meeting Link"
                                    fullWidth
                                    variant="outlined"
                                    value={scheduleInterviewRecord?.meeting_link || ""}
                                    error={Boolean(meetingModeError)}
                                    helperText={meetingModeError}
                                    onChange={(event) => {
                                        setScheduleInterviewRecord((state) => ({
                                            ...state,
                                            meeting_link: event.target.value,
                                        }));
                                        setMeetingModeError("");
                                    }}
                                />
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    margin="dense"
                                    label="Location"
                                    fullWidth
                                    variant="outlined"
                                    value={scheduleInterviewRecord?.address || ""}
                                    error={Boolean(meetingModeError)}
                                    helperText={meetingModeError}
                                    onChange={(event) => {
                                        setScheduleInterviewRecord((state) => ({
                                            ...state,
                                            address: event.target.value,
                                        }));
                                        setMeetingModeError("");
                                    }}
                                />
                            </Grid>
                        )}
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    p: 1.5,
                                    borderRadius: "14px",
                                    backgroundColor: "#F9F9F9",
                                }}
                            >
                                <Typography fontWeight={600} fontSize="14px">
                                    Required fields
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Interviewer, date-time, mode, timezone, and the correct location detail are required before scheduling.
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <MDBox>
                        {/* <MDBox
                        display="flex"
                        justifyContent="space-between"
                        alignItems={{ xs: "flex-start", sm: "center" }}
                        flexDirection={{ xs: "column", sm: "row" }}
                      >
                        <MDBox display="flex" alignItems="center">
                          <MDBox ml={2} lineHeight={0}>
                            <MDTypography variant="h7" fontWeight="small">
                              GMeet
                            </MDTypography>
                          
                          </MDBox>
                        </MDBox>
                        <MDBox
                          display="flex"
                          justifyContent="flex-end"
                          alignItems="center"
                          width={{ xs: "100%", sm: "auto" }}
                          mt={{ xs: 1, sm: 0 }}
                        >
                    
                          <MDBox mr={1} display="flex" justifyContent="center" alignItems="center" >
                            <Switch checked={gmeet} onChange={handleSetGmeet} />
                            {gmeet && (
                            gmeetAuthenticated ? (
                              <img src={verifiedIcon} height="24" width="24" />
                           )
                             : (
                              <MDButton
                              onClick={() => {
                                     getAuthToken();
                              }}
                              sx={{ backgroundColor: "lightGrey",  }}
                            >
                              { "Authenticate"}
                            </MDButton>
                            ))}
                          </MDBox>
                        </MDBox>
                      </MDBox> */}
                    </MDBox>
                </DialogContent>
                <DialogActions style={{ justifyContent: "space-between", padding: "16px 24px 20px" }}>
                    <Typography variant="body2" color="text.secondary">
                        Required: interviewer, date-time, mode, and location details.
                    </Typography>
                    <Box display="flex" gap={1}>
                    <MDButton
                        variant="gradient"
                        color="dark"
                        onClick={handleScheduleInterviewClose}
                    >
                        Cancel
                    </MDButton>
                    <MDButton
                        variant="gradient"
                        color="dark"
                        onClick={() => {
                            if (gmeetAuthenticated) {
                                handleScheduleInterview();
                            } else {
                                alert("You are not authenticated with Google Meet & Calendar Events. Please enable it from recruitment settings")
                            }

                        }}
                    >
                        Schedule
                    </MDButton>
                    </Box>
                </DialogActions>
            </Dialog>
        </>
    )
}

export const InterviewNameDialog = ({ interviewDetailsDialog, selectedInterview, setInterviewDetailsDialog, getEmployeeNameById, getTimeFromDateTime, getDateFromDateTime, handleInterviewerNameClose }) => {
    return (
        <>
            <Dialog
                PaperProps={{
                    style: {
                        backgroundColor: "#f8f8f8",
                        boxShadow: "none",
                        width: "700px",
                        height: "500px",
                        maxWidth: "none",
                        borderRadius: "10px",
                    },
                }}
                open={interviewDetailsDialog}
                onClose={() => setInterviewDetailsDialog(false)}
            >
                {selectedInterview && (
                    <React.Fragment>
                        <DialogTitle
                            style={{
                                padding: "20px",
                                borderBottom: "1px solid #ccc",
                                background: "white",
                                color: "white",
                            }}
                        >
                            <Typography variant="h5" style={{ color: "black" }}>
                                Interview Details
                            </Typography>
                        </DialogTitle>
                        <DialogContent style={{ padding: "30px" }}>
                            <Grid container spacing={3}>
                                <Grid item xs={6}>
                                    <TextField
                                        margin="dense"
                                        id="interviewer"
                                        label="Interviewer Name"
                                        type="text"
                                        fullWidth
                                        variant="standard"
                                        name="interviewer"
                                        value={getEmployeeNameById(selectedInterview.interviewer)}
                                        inputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        margin="dense"
                                        id="time"
                                        label="Time"
                                        type="text"
                                        fullWidth
                                        variant="standard"
                                        name="time"
                                        value={getTimeFromDateTime(selectedInterview.datetime)}
                                        inputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        margin="dense"
                                        id="date"
                                        label="Date"
                                        type="text"
                                        fullWidth
                                        variant="standard"
                                        name="date"
                                        value={getDateFromDateTime(selectedInterview.datetime)}
                                        inputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        margin="dense"
                                        id="rating"
                                        label="Rating"
                                        type="text"
                                        fullWidth
                                        variant="standard"
                                        name="rating"
                                        value={selectedInterview.rating}
                                        inputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        margin="dense"
                                        id="feedback"
                                        label="Feedback"
                                        type="text"
                                        fullWidth
                                        variant="standard"
                                        name="feedback"
                                        value={selectedInterview.feedback}
                                        inputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        margin="dense"
                                        id="expereince"
                                        label="Experience"
                                        type="text"
                                        fullWidth
                                        variant="standard"
                                        name="experience"
                                        value={selectedInterview.expereince}
                                        inputProps={{ readOnly: true }}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <MDButton
                                variant="gradient"
                                color="dark"
                                onClick={handleInterviewerNameClose}
                            >
                                Cancel
                            </MDButton>
                        </DialogActions>
                    </React.Fragment>
                )}
            </Dialog>
        </>
    )
}
